import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BeatsService } from 'src/app/services/beats-service/beats.service';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Component({
  selector: 'ipm-home-bpm-arena',
  templateUrl: './home-bpm-arena.component.html',
  styleUrls: ['./home-bpm-arena.component.scss']
})
export class HomeBpmArenaComponent implements OnInit {
  isDataLoaded: boolean = false;
  beatListData: Array<any> = [];
  bannerDiscount = "50";
  @Input() isShowOnlyBanner: boolean = false;

  constructor(private beatService: BeatsService,
  private commonService: CommonService,
  private routerActivate: ActivatedRoute,
  private router: Router) {}

  ngOnInit(): void {
    if (!this.isShowOnlyBanner) {
      this.beatList();
    }
  }

  beatList() {
    this.beatService.getOneScrollAlgo(0, true).subscribe((res) => {
      if (res) {
        let filteredSaleInfo: Array<any>  = res.filter(item => item?.sale_info)
        this.beatListData = filteredSaleInfo;
        this.isDataLoaded =  true;
      }
    },(error) => {
      this.commonService.showToastError(error);
      this.isDataLoaded =  true;
    });
  }

  gotoLatestBeat() {
    let params = {
      bpmOffer: this.bannerDiscount
    }
    this.router.navigate(['/latestbeats'], { relativeTo: this.routerActivate ,queryParams: params});
  }
}
